module.exports = __webpack_public_path__ + "images/home/index/mobile/values-assign-screenshot-f31a50c7a0cfeba7715cac301119a175.png";